import { render, staticRenderFns } from "./MsPopupV2.vue?vue&type=template&id=5eb1fea9&scoped=true"
import script from "./MsPopupV2.vue?vue&type=script&lang=js"
export * from "./MsPopupV2.vue?vue&type=script&lang=js"
import style0 from "./MsPopupV2.vue?vue&type=style&index=0&id=5eb1fea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1fea9",
  null
  
)

export default component.exports